import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { LogoMain } from './Logo';

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="bg-white sticky top-0 z-50" data-testid="global-header">
      <div className="border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex justify-between items-center py-4">
            <Link to="/" data-testid="header-logo" className="flex-shrink-0">
              <LogoMain height={32} className="md:hidden" />
              <LogoMain height={44} className="hidden md:block" />
            </Link>

            <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
              <Link to="/products" className="text-sm font-medium text-[#333] hover:text-[#1C3B2A] transition">Test Edilmiş Ürünler</Link>
              <Link to="/about" className="text-sm font-medium text-[#333] hover:text-[#1C3B2A] transition">Hakkımızda</Link>
              <Link to="/submit" className="bg-[#1C3B2A] text-white px-5 py-2.5 text-xs font-semibold tracking-wide rounded hover:bg-[#152e21] transition" data-testid="header-submit-btn">
                SATICI ÜRÜN TEST BAŞVURUSU
              </Link>
            </nav>

            <button className="md:hidden p-2 text-[#333]" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle">
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>

          {mobileOpen && (
            <div className="md:hidden border-t border-neutral-100 py-4 space-y-3" data-testid="mobile-menu">
              <Link to="/products" onClick={() => setMobileOpen(false)} className="block text-sm font-medium text-[#333] py-2">Test Edilmiş Ürünler</Link>
              <Link to="/about" onClick={() => setMobileOpen(false)} className="block text-sm font-medium text-[#333] py-2">Hakkımızda</Link>
              <Link to="/submit" onClick={() => setMobileOpen(false)} className="block bg-[#1C3B2A] text-white px-5 py-2.5 text-xs font-semibold tracking-wide text-center rounded">
                SATICI ÜRÜN TEST BAŞVURUSU
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
